import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import {
    SupplierAndStockLocationDTORuntype,
    SupplierAndStockLocationPatchDTORuntype,
    SupplierAndStockLocationPostDTORuntype,
} from './supplierAndStockLocationBackendTypes';

export const supplierAndStockLocationEndpoints = {
    'POST /suppliers-and-stock-locations/bulk': endpoint({
        description: 'Returns a list of supplier-and-stock-locations given their IDs',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.object({ ids: z.array(z.string()) }),
        responseBody: z.object({ items: z.array(SupplierAndStockLocationDTORuntype) }),
    }),

    'POST /suppliers-and-stock-locations': endpoint({
        description: 'Creates a new supplier-and-stock-location',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: SupplierAndStockLocationPostDTORuntype,
        responseBody: z.object({ data: SupplierAndStockLocationDTORuntype }),
        invalidates: [
            'GET /suppliers-and-stock-locations',
            'POST /suppliers-and-stock-locations/bulk',
            'GET /email-template',
            'GET /sourcing-templates',
        ],
    }),

    'PATCH /suppliers-and-stock-locations/:id': endpoint({
        description: 'Updated a supplier-and-stock-location',
        pathParams: z.object({ id: z.string() }),
        queryParams: z.undefined(),
        requestBody: SupplierAndStockLocationPatchDTORuntype,
        responseBody: z.object({ data: SupplierAndStockLocationDTORuntype }),
        invalidates: [
            'GET /suppliers-and-stock-locations',
            'POST /suppliers-and-stock-locations/bulk',
            'GET /email-template',
            'GET /sourcing-templates',
        ],
    }),

    'GET /suppliers-and-stock-locations': endpoint({
        description: 'Returns all supplier-and-stock-locations',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({ data: z.array(SupplierAndStockLocationDTORuntype) }),
    }),

    'POST /suppliers-and-stock-locations/bulk-delete': endpoint({
        description: 'Deletes multiple suppliers and stock locations',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.object({
            ids: z.array(z.string()),
        }),
        responseBody: z.unknown(),
        invalidates: ['GET /suppliers-and-stock-locations'],
    }),
};
